const CSS_VAR_PATTERN = /var\(--.+?\)/

export default function extractVariableRules() {
  return {
    postcssPlugin: 'extractCssVariableRules',
    Once(css, { result: _result }) {
      css.walkComments(function (comment) {
        comment.remove()
      })

      css.walkRules(function (rule) {
        rule.walkComments(function (comment) {
          comment.remove()
        })

        rule.walkDecls(function (decl) {
          if (!decl.value.match(CSS_VAR_PATTERN)) decl.remove()
        })

        if (!rule.nodes.length) rule.remove()
      })

      css.walkAtRules(function (atRule) {
        if (!atRule.nodes) atRule.remove()

        atRule.walkDecls(function (decl) {
          if (!decl.value.match(CSS_VAR_PATTERN)) decl.remove()
        })

        if (!atRule.nodes || (atRule.nodes && !atRule.nodes.length)) atRule.remove()
      })
    },
  }
}

export const postcss = true
